import * as types from "./actionTypes";
import { successSnackbar, failureSnackbar } from "actions/snackbar/actions";

export const createCustomer = customer => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const authorId = getState().firebase.auth.uid;

    const payload = {
      ...customer,
      authorId: authorId,
      createdAt: new Date()
    };

    return firestore
      .collection("customers")
      .add(payload)
      .then(() => {
        dispatch({ type: types.CUSTOMER_CREATE_SUCCESS });
        dispatch(successSnackbar("Customer created successfully"));
      })
      .catch(error => {
        dispatch({ type: types.CUSTOMER_CREATE_ERROR }, error);
        dispatch(failureSnackbar("Customer create failure"));
      });
  };
};

export const updateCustomer = (docId, customer) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const authorId = getState().firebase.auth.uid;

    const payload = {
      ...customer,
      modifiedBy: authorId,
      createdAt: new Date()
    };

    return firestore
      .collection("customers")
      .doc(docId)
      .update(payload)
      .then(() => {
        dispatch({ type: types.CUSTOMER_UPDATE_SUCCESS });
        dispatch(successSnackbar("Customer updated successfully"));
      })
      .catch(err => {
        dispatch({ type: types.CUSTOMER_UPDATE_ERROR }, err);
        dispatch(failureSnackbar("Customer update failure"));
      });
  };
};

export const deleteCustomer = docId => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    return firestore
      .collection("customers")
      .doc(docId)
      .delete()
      .then(() => {
        dispatch({ type: types.CUSTOMER_DELETE_SUCCESS });
        dispatch(successSnackbar("Customer deleted successfully"));
      })
      .catch(err => {
        dispatch({ type: types.CUSTOMER_DELETE_ERROR }, err);
        dispatch(failureSnackbar("Customer delete failure"));
      });
  };
};
